// Liquid glass: inject the ambient aurora + the SVG refraction filter once.
// The aurora gives the glass colour to bend; the filter is referenced by
// `backdrop-filter: url(#lg-refract)` in styles.css (Chromium only — other
// browsers keep the frosted blur fallback).
export function initLiquidGlass() {
  if (typeof document === 'undefined') return;

  function mount() {
    if (document.getElementById('lg-aura')) return;

    const aura = document.createElement('div');
    aura.className = 'lg-aura';
    aura.id = 'lg-aura';
    aura.setAttribute('aria-hidden', 'true');
    document.body.insertBefore(aura, document.body.firstChild);

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
    svg.innerHTML =
      '<defs>' +
        '<filter id="lg-refract" x="-20%" y="-20%" width="140%" height="140%" color-interpolation-filters="sRGB">' +
          '<feTurbulence type="fractalNoise" baseFrequency="0.009 0.013" numOctaves="2" seed="7" result="n"/>' +
          '<feGaussianBlur in="n" stdDeviation="2.2" result="sn"/>' +
          '<feDisplacementMap in="SourceGraphic" in2="sn" scale="14" xChannelSelector="R" yChannelSelector="G"/>' +
        '</filter>' +
      '</defs>';
    document.body.appendChild(svg);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
}
